import type { JsonBody, JsonResponse } from '@/types/api/helpers'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { fetchClient } from '../../../api/typedClient'

interface CreateCrossroadsMappingPayload {
  type: string
  goids: string[]
  display_name: string
  source_id: string
  source_system: string
  matching_info: Record<string, unknown>
  extra_data: Record<string, unknown>
}

interface MappingOptions {
  referenceDataId: string
}

export function useCreateCrossroadsMapping() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async ({
      payload,
      options,
    }: {
      payload: CreateCrossroadsMappingPayload
      options: MappingOptions
    }) => {
      const { data, error } = await fetchClient.PUT(
        // @ts-expect-error TODO: Add /crossroads/mappings/{id} to OpenAPI spec
        `/crossroads/mappings/${options.referenceDataId}`,
        { body: payload as JsonBody<'/crossroads/mappings/{id}', 'put'> },
      )
      if (error) {
        throw new Error(`Failed to create mapping: ${JSON.stringify(error)}`)
      }
      return data as JsonResponse<'/crossroads/mappings/{id}', 'put'>
    },
    onSuccess: () => {
      // Invalidate and refetch crossroads mappings
      queryClient.invalidateQueries({ queryKey: ['crossroads-mappings'] })
    },
  })
}
